import { TextField, Autocomplete } from "@mui/material";
import PropTypes from "prop-types";
import { useTheme } from "@emotion/react";
import { useStyles } from "./styles";
import { useState, useEffect } from "react";

const AutoCompleteDropdown = ({
  required,
  Id,
  lists,
  value,
  setDropdownValue,
  errorTitle,
  noOptionsText,
}) => {
  const theme = useTheme();
  const classes = useStyles({ theme });
  const [inputValue, setInputValue] = useState(value || "");
  const [showAllOptions, setShowAllOptions] = useState(false);

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  return (
    <Autocomplete
      required={required}
      fullWidth
      id={Id}
      options={lists}
      value={value || null}
      inputValue={inputValue}
      onOpen={() => {
        setTimeout(() => {
          const optionEl = document.querySelector(`[data-name="${value}"]`);
          optionEl?.scrollIntoView({
            block: "center",
          });
        }, 10);
        setShowAllOptions(true);
      }}
      freeSolo={false}
      clearOnBlur
      noOptionsText={noOptionsText || "No options"}
      onClose={() => {
        setShowAllOptions(false);
      }}
      filterOptions={(options, state) => {
        if (showAllOptions) {
          return options;
        }
        return options.filter((option) => {
          return option.Name.toLowerCase().includes(
            state.inputValue.toLowerCase()
          );
        });
      }}
      renderOption={(props, option) => {
        const { key, className, ...otherProps } = props;
        return (
          <li
            key={`${option.id}-${option.Name}`}
            data-testid={"menu-item"}
            {...otherProps}
            className={`${className} ${classes.options}`}
            style={{
              backgroundColor: option.Name === value ? "#b80351" : undefined,
              color:
                option.Name === value ? "#fff" : theme.palette.text.primary,
            }}
            data-name={option.Name}
          >
            {option.Name}
          </li>
        );
      }}
      getOptionLabel={(option) => option.Name + option.id || ""}
      onChange={(e, newValue, reason) => {
        if (newValue && reason === "selectOption") {
          setDropdownValue(e, newValue.Name);
          setInputValue(newValue.Name);
        }
      }}
      onInputChange={(event, newInputValue, reason) => {
        if (reason === "input" || reason === "clear") {
          setShowAllOptions(false);
          setInputValue(newInputValue);
        }
      }}
      renderInput={(params) => (
        <TextField
          onBlur={(evt) => {
            const match = lists.find((o) => o.Name === inputValue);
            if (!match) {
              setInputValue("");
              setDropdownValue("");
            } else {
              setDropdownValue(evt, match.Name);
            }
          }}
          color="default"
          helperText={errorTitle}
          error={errorTitle?.length}
          placeholder="Select"
          fullWidth
          {...params}
          variant="outlined"
          slotProps={{
            inputLabel: {
              shrink: false,
            },
          }}
        />
      )}
    />
  );
};

AutoCompleteDropdown.propTypes = {
  required: PropTypes.bool,
  Id: PropTypes.any,
  lists: PropTypes.array,
  value: PropTypes.string,
  setDropdownValue: PropTypes.func,
  errorTitle: PropTypes.string,
  noOptionsText: PropTypes.string,
  className: PropTypes.string,
  key: PropTypes.any,
};
export default AutoCompleteDropdown;
